// extracted by mini-css-extract-plugin
module.exports = {"heading":"ArticleCardList_heading__H2MUh","cardList":"ArticleCardList_cardList__BSSJ1"};